import React, { Component } from 'react';
import { Container,  Row, Col } from 'reactstrap';
import Button from '@mui/material/Button';
//import Pagination from '@mui/material/Pagination';
import { Navigate } from "react-router-dom";
import { Snackbar } from '@mui/material';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { alpha, styled } from '@mui/material/styles';

import StudentDataService from '../services/StudentService';


import AuthService from "../services/LoginService";
import EventBus from "../common/EventBus";

import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import VisibilityIcon from '@mui/icons-material/Visibility';


import { AddStudent } from './AddStudent';
const ODD_OPACITY = 0.2;
const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));

class StudentList extends Component {

    emptyStudent = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        zipCode: '',
        city: '',
        id: ''
    };


    constructor(props) {
        super(props);
        this.state = {
            contracts: [],
            students: [],
            page: 0,
            count: 0,
            pageSize: 100,
            firstNameFilter: null,
            lastNameFilter: null,
            currentUser: { username: "" },
            redirect: null,
            addStudentShow: false,
            currentStudent: this.emptyStudent,
            snackbaropen: false
        };
        this.pageSizes = [ 10, 25, 50, 100];


        this.remove = this.remove.bind(this);
        this.retrieveStudents = this.retrieveStudents.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.editStudent = this.editStudent.bind(this);
        this.refreshStudent = this.refreshStudent.bind(this);
    }


    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        //console.log(currentUser);
        if (!currentUser) {
            this.setState({ redirect: "/login" });
        } else {
            this.retrieveStudents();
        }
    }

    componentDidUpdatexx() {
        //this.retrieveStudents();
    }

    componentDidUpdate(previousProps, previousState) {
        //console.log(this.props.currentstudent);
        if (previousProps.currentstudent !== this.props.currentstudent) {

            this.retrieveStudents();
        }
    }



    retrieveStudents() {
        const { firstNameFilter, lastNameFilter, page, pageSize } = this.state;
        const params = this.getRequestParams(firstNameFilter, lastNameFilter, page, pageSize);
        // console.log(params);
        StudentDataService.getAll(params)
            .then((response) => {
                const { students, totalItems } = response.data;

                this.setState({
                    students: students,
                    count: totalItems,
                });
                //console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            });
        /*
        ContractService.getAll(params)
            .then((response) => {
                const { contracts, totalPages } = response.data;

                this.setState({
                    contracts: contracts,
                    count: totalPages,
                });
                //console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            });
            */

    }

    getRequestParams(firstNameFilter, lastNameFilter, page, pageSize) {
        let params = {};

        if (firstNameFilter) {
            params["firstNameFilter"] = firstNameFilter;
        }
        if (lastNameFilter) {
            params["lastNameFilter"] = lastNameFilter;
        }
        if (page) {
            params["page"] = page;
        }

        if (pageSize) {
            params["size"] = pageSize;
        }

        return params;
    }

    remove(id) {
        StudentDataService.delete(id)
            .then((response) => {
                const { error, message } = response.data;
                this.setState({ snackbaropen: true, snackbarmsg: error + ' : ' + message });
                this.retrieveStudents();
            })
            .catch((err) => {
                console.log(err);
                const { error, message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: error + ' : ' + message });
            });
    }

    handlePageChange(value) {
        console.log('handlePageChange ')
        //console.log(event)
        console.log(value)
        this.setState(
            {
                page: value.page,
                pageSize: value.pageSize,
            },
            () => {
                this.retrieveStudents();
            }
        );
    }

    handlePageSizeChange(event) {
        this.setState(
            {
                pageSize: event.target.value,
                page: 1
            },
            () => {
                this.retrieveStudents();
            }
        );
    }

    snackbarClose = (event) => {
        this.setState({ snackbaropen: false });
    }


    editStudent(student) {
        // studentId.preventDefault();
        console.log('editStudent');
        console.log(student);

        //console.log(student);
        this.setState({ currentStudent: student });
        this.setState({ addStudentShow: true });
    }

    genPopComment(comment) {
        const popover = (
            <Popover id="popover-basic">
                <Popover.Header >commentaires</Popover.Header>
                <Popover.Body>
                    {comment}
                </Popover.Body>
            </Popover>
        );
        return popover;
    }

    refreshStudent(newStudent) {
        console.log('update newStudent : ');
        console.log(newStudent);
        // console.log('In ... applyFilter : ');
        //console.log(this.state);
        let newStudents = this.state.students.map((row) =>
            row.id === newStudent.id ? newStudent : row,
        );

        this.setState({
            students: newStudents,
        });
    }


    render() {

        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }

        const {
            students,
            page,
            count,
            pageSize,
            isLoading,
        } = this.state;

        const columns = [
            { field: 'id', headerName: 'ID', maxwidth: 80 },
            {
                field: 'salutation',
                //headerName: 'Mr/Mme',
                renderHeader: () => (
                    <strong>
                        {'Me/Mme'}
                    </strong>
                ),
                maxwidth: 80,
                flex: 0.2,
                //editable: true,
            },
            {
                field: 'lastName',
                headerName: 'Nom',
                minwidth: 100,
                flex: 0.2,
                //editable: true,
            },
            {
                field: 'firstName',
                headerName: 'Prénom',
                minwidth: 100,
                flex: 0.2,
                //editable: true,
            },
            {
                field: 'phone',
                headerName: 'Téléphone',
                minwidth: 100,
                flex: 0.2,
                //editable: true,
            },
            {
                field: 'email',
                headerName: 'Email',
                minwidth: 100,
                flex: 0.3,

            },
            {
                field: 'company',
                headerName: 'Entreprise',
                minwidth: 100,
                flex: 0.2,

            },
            {
                field: 'address',
                headerName: 'Adresse',
                minwidth: 100,
                flex: 0.5,
                valueGetter: (param) => {
                    //console.log(param);
                    return `${param.row.address}  ${param.row.zipCode} ${param.row.city}`;
                }
            },
            {
                field: 'comments',
                headerName: 'CMNT',
                sortable: false,
                minwidth: 100,
                flex: 0.2,
                renderCell: (params) => (
                    <OverlayTrigger rootClose trigger="click" placement="right" overlay={this.genPopComment(`${params.row.comments}`)} >
                        <IconButton aria-label="edit" color="primary" >
                            <VisibilityIcon />
                        </IconButton>
                    </OverlayTrigger>
                ),
            },
            {
                field: 'actions',
                headerName: 'Actions',
                sortable: false,
                minwidth: 100,
                flex: 0.3,
                renderCell: (params) => (
                    <div>

                        <IconButton aria-label="edit" color="primary" onClick={() => { this.editStudent(params.row) }} >
                            <ModeEditIcon />
                        </IconButton>

                        <IconButton aria-label="delete" color="primary" onClick={() => this.remove(`${params.row.id}`)}>
                            <DeleteIcon />
                        </IconButton>
                    </div>
                ),
            },
        ];


        const pageSizes = this.pageSizes;


        let addStudentClose = () => this.setState({ addStudentShow: false, currentStudent: this.emptyStudent });

        if (isLoading) {
            return <p>Loading...</p>;
        }

        //const reload = () => window.location.reload();
        //const rows = students;




        //const [pageSize2, setPageSize2] = React.useState(5);
        let paginationModel = {
            page: page,
            pageSize: pageSize
        };

        //console.log('count = ' + count);

        const columnVisibilityModel = {
            id: false,
        };

        return (
            <div>

                <Container fluid>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        open={this.state.snackbaropen}
                        autoHideDuration={3000}
                        onClose={this.snackbarClose}
                        message={<span id='message-id'> {this.state.snackbarmsg}  </span>}
                        action={[
                            <IconButton
                                key="close"
                                aria-label='Close'
                                color='inherit'
                                onClick={this.snackbarClose}
                            >X</IconButton>
                        ]}
                    ></Snackbar>

                    <br />
                    <Row>
                        <Col xs={10} md={10}><h3>Stagiaires</h3></Col>
                        <Col xs={2} md={2}>
                            <Button  variant="contained" onClick={() => { this.editStudent(this.state.currentStudent) }}>Ajout Stagiaire</Button>
                        </Col>
                    </Row>

                </Container>

                <div style={{ height: 800, width: '100%' }}>
                    <StripedDataGrid
                        rows={students}
                        columns={columns}
                        pageSizeOptions={pageSizes}

                        rowCount={count}
                        loading={isLoading}
                        columnVisibilityModel={columnVisibilityModel}

                        paginationModel={paginationModel}
                        paginationMode="server"
                        onPaginationModelChange={this.handlePageChange}

                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                        }
                    // pagination
                    //checkboxSelection
                    //disableSelectionOnClick
                    />
                    <AddStudent show={this.state.addStudentShow} onHide={addStudentClose} refreshParentStudent={this.refreshStudent} currentstudent={this.state.currentStudent} ></AddStudent>
                </div>

            </div>
        );



    }

}
export default StudentList;